module.exports = __webpack_public_path__ + "fonts/notosans-light-web.96341b3.woff";